/* eslint global-require: "off" */
/* eslint import/no-unresolved: [2, { ignore: ['./prod', './staging', './dev'] }] */
//
// Firebase config selection. The config files are authoritative for the
// documented deploy scripts:
//   yarn deploy          -> NODE_ENV=production              -> ./prod   (eropenpal-prod)
//   yarn deploy-staging  -> NODE_ENV=production + STAGING     -> ./staging (eropenpal-dev)
//   yarn start           -> development                       -> ./dev    (eropenpal-dev)
//
// REACT_APP_FIREBASE_* env vars may override for CI/CD, BUT a production
// (non-staging) build is HARD-PINNED to eropenpal-prod. A committed/local
// .env.local with dev values once pointed eropenpal.com at the dev database
// (CRA loads .env.local into every build, including production), so env vars
// that target any project other than eropenpal-prod are ignored in a prod
// build. Never put dev config in a committed .env.local.

const isStaging = process.env.REACT_APP_STAGING === 'true';
const isProductionBuild =
  process.env.NODE_ENV === 'production' && !isStaging;

// 1) pick the authoritative config file from the build mode
let config;
if (isStaging) {
  config = require('./staging');
} else if (process.env.NODE_ENV === 'production') {
  config = require('./prod');
} else {
  config = require('./dev');
}

// 2) optional CI/CD override via env vars - refused if it would silently send
//    a production build at a non-prod project
if (process.env.REACT_APP_FIREBASE_API_KEY) {
  const envProjectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  if (isProductionBuild && envProjectId !== 'eropenpal-prod') {
    // eslint-disable-next-line no-console
    console.error(
      `[config] Ignoring REACT_APP_FIREBASE_* (projectId="${envProjectId}") ` +
        'in a production build; using ./prod (eropenpal-prod) instead.'
    );
  } else {
    config = {
      firebaseConfig: {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
        projectId: envProjectId,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
        measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
      }
    };
  }
}

module.exports = config;
